/* Lycos Vounó: selector de muestras de regalo en la bolsa */
(function () {
  if (window.__lvRegalo) return;
  window.__lvRegalo = true;
  var fixing = false, mounting = false;

  function parse(html, sel) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
  }

  function wrapper() {
    return document.querySelector('cart-drawer #CartDrawer-CartItems .drawer__cart-items-wrapper');
  }

  function markRows(box) {
    var all = (box.getAttribute('data-muestras') || '').split(',').filter(Boolean);
    var free = (box.getAttribute('data-cortesia') || '').split(',').filter(Boolean);
    document.querySelectorAll('cart-drawer tr.cart-item').forEach(function (tr) {
      var a = tr.querySelector('a.cart-item__name, a[href*="variant="]');
      var m = a && (a.getAttribute('href') || '').match(/variant=(\d+)/);
      var id = m ? m[1] : null;
      tr.classList.toggle('cart-item--muestra', !!id && all.indexOf(id) > -1);
      tr.classList.toggle('is-cortesia', !!id && free.indexOf(id) > -1);
    });
  }

  function mount() {
    var w = wrapper();
    if (!w || mounting) return;
    mounting = true;
    fetch('/?sections=lv-regalo', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var box = parse(j['lv-regalo'] || '', '[data-lv-regalo]');
        var w2 = wrapper();
        if (!box || !w2) return;
        var old = w2.querySelector('[data-lv-regalo]');
        if (old) old.replaceWith(box); else w2.appendChild(box);
        markRows(box);
        check(box);
      })
      .catch(function () {})
      .finally(function () { mounting = false; });
  }

  function applyDrawer(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var n = parse(sections['cart-drawer'], '.drawer__inner');
      var cur = document.querySelector('cart-drawer .drawer__inner');
      if (n && cur) cur.innerHTML = n.innerHTML;
      var nd = parse(sections['cart-drawer'], 'cart-drawer');
      var d = document.querySelector('cart-drawer');
      if (nd && d) d.classList.toggle('is-empty', nd.classList.contains('is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      var b = parse(sections['cart-icon-bubble'], '.shopify-section');
      var t = document.getElementById('cart-icon-bubble');
      if (b && t) t.innerHTML = b.innerHTML;
    }
  }

  function update(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { applyDrawer(j && j.sections); return j; });
  }

  function check(box) {
    if (fixing || !box) return;
    var fix;
    try { fix = JSON.parse('{' + (box.getAttribute('data-lv-fix') || '') + '}'); } catch (e) { return; }
    if (!Object.keys(fix).length) return;
    fixing = true;
    update(fix).finally(function () { fixing = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lv-muestra]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-lv-regalo]');
    if (!box || box.classList.contains('is-busy')) return;
    var id = String(btn.getAttribute('data-lv-muestra'));
    var allowed = parseInt(box.getAttribute('data-allowed'), 10) || 0;
    var sel = [];
    try { sel = JSON.parse(box.getAttribute('data-selected') || '[]').map(String); } catch (err) {}
    var updates = {};
    if (sel.indexOf(id) > -1) {
      updates[id] = 0;
    } else {
      if (allowed < 1) return;
      if (sel.length >= allowed) updates[sel[sel.length - 1]] = 0;
      updates[id] = 1;
    }
    box.classList.add('is-busy');
    btn.classList.add('is-loading');
    update(updates).catch(function () { box.classList.remove('is-busy'); });
  });

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = wrapper();
        if (w && !w.querySelector('[data-lv-regalo]')) mount();
      }, 60);
    }).observe(drawer, { childList: true, subtree: true });
    mount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
